import { MigrationStrategies } from 'rxdb';

export const SummaryPagePreferencesMigrations: MigrationStrategies = {};
